import * as yup from 'yup';

const SITE_NO_REGEX =
  /((http|https):\/\/)?([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/;
export const schema = yup
  .object({
    num_cnpj: yup
      .string()
      .required()
      .test((value) => {
        value = value?.replace(/\D/g, '');
        return value?.length === 14;
      }),
    name: yup.string().required(),
    email: yup.string().email().notRequired().nullable(true),
    site: yup
      .string()
      .matches(SITE_NO_REGEX, {
        message: 'not valid site no',
        excludeEmptyString: true,
      })
      .notRequired()
      .nullable(true),
    num_cep: yup.string().required(),
    des_logradouro: yup.string().required(),
    num_endereco: yup.string().required(),
    des_bairro: yup.string().trim().min(2).required(),
    cidades: yup
      .object()
      .shape({
        value: yup.number().required(),
        ufValue: yup.string().notRequired(),
        label: yup.string().required(),
      })
      .required(),
    num_ie: yup.string().notRequired(),
  })
  .required();

export const schemaBandeiras = yup
  .object({
    des_bandeira: yup.string().required(),
    cod_cc: yup
      .object({
        value: yup.number().required(),
        label: yup.string().required(),
      })
      .required(),
    per_taxa_credito: yup.string().required(),
    num_condicao_credito: yup.number().required(),
    per_taxa_debito: yup.string().required(),
    num_condicao_debito: yup.number().required(),
    per_taxa_parcelado: yup.string().required(),
    num_condicao_parcela: yup.number().required(),
  })
  .required();
